import React, { useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setTableData } from './store/dataSlice'
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'
import Tooltip from 'components/Ui/Tooltip'
import { ConfirmationModal, Table } from 'components/Ui'
import { deleteApiRecord } from 'services/TransportProviderServicesService'
import { Success } from 'utils/alerts'
import useAuth from 'utils/hooks/useAuth'
injectReducer('transportProviderService', reducer)

export default function TransportProviderService() {
    const dispatch = useDispatch()
    const { checkPermission } = useAuth()
    const { data, tableData, loading } = useSelector(
        (state) => state.transportProviderService.data,
    )

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
    ])

    const fetchData = () => dispatch(getData({ ...tableData }))

    const handleDelete = (id) => {
        deleteApiRecord(id)
            .then(() => {
                Success('Deleted Successfully!')
                fetchData()
            })
            .catch((error) => error)
    }

    const columns = useMemo(
        () => [
            {
                field: 'transport_provider',
                header: 'Transport Service Provider',
                className: 'min-w-[150px]',
                renderCell: (row) => row?.transport_provider?.name,
            },
            {
                field: 'carrier_name',
                header: 'Carrier Name',
                className: 'min-w-[150px]',
            },
            {
                field: 'name',
                header: 'Service Name',
                className: 'min-w-[150px]',
            },
            {
                field: 'short_code',
                header: 'Service Code',
                className: 'min-w-[150px]',
            },
            {
                header: 'Action',
                field: 'action',
                className: 'px-4',
                renderCell: (row) => {
                    return (
                        <div className="flex items-center gap-3">
                            {checkPermission(
                                'transport-provider-service',
                                'edit',
                            ) ? (
                                <Tooltip title={'Edit'}>
                                    <Link
                                        to={`/transport-service-provider/transport-provider-service/${row.id}/edit`}
                                        className="hover:text-primary"
                                    >
                                        <HiOutlinePencil size={20} />
                                    </Link>
                                </Tooltip>
                            ) : null}
                            {checkPermission(
                                'transport-provider-service',
                                'delete',
                            ) ? (
                                <Tooltip title={'Delete'}>
                                    <ConfirmationModal
                                        message={
                                            'Are you sure you want to delete this record!'
                                        }
                                        onConfirm={() => {
                                            handleDelete(row.id)
                                        }}
                                    >
                                        <span className="hover:text-danger">
                                            <HiOutlineTrash size={20} />
                                        </span>
                                    </ConfirmationModal>
                                </Tooltip>
                            ) : null}
                        </div>
                    )
                },
            },
        ],
        // eslint-disable-next-line
        [
            tableData.sort,
            tableData.query,
            tableData.pageIndex,
            tableData.pageSize,
            tableData.selectedTab,
            tableData.checkBox,
        ],
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Transport Provider Service
                </h2>
            </div>
            <Table
                loading={loading}
                datas={data}
                columns={columns}
                add_new={
                    checkPermission('transport-provider-service', 'create')
                        ? '/transport-service-provider/transport-provider-service/create'
                        : ''
                }
                pagingData={tableData}
                onChange={(e) => dispatch(setTableData(e))}
            />
        </>
    )
}
